// extracted by mini-css-extract-plugin
export default {"card":"InfoCard_card__R66CB","img":"InfoCard_img__AVMOT"};